// React Imports
import { ReactElement, useEffect, useState } from "react";

// Third Party Libraries Imports
import { Form } from "antd";
import { useNavigate } from "react-router-dom";

// Local Imports
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import Label from "../../components/label/label.component";
import CustomInput from "../../components/custom-input/custom-input.component";


const EditPaciLog: React.FC = (): ReactElement => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const [submitLoginForm, setSubmitLoginForm] = useState(false);

  useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setSubmitLoginForm(true);
      },
      () => {
        setSubmitLoginForm(false);
      }
    );
  }, [values]);

  return (
    <section className="flex flex-col">
      <BreadcrumbComponent />
      <div className="flex flex-col bg-white p-[2%] rounded-[20px]">
        <h3 className=" text-black-500 text-base font-semibold border-b-[1px] border-gray-900 pb-3 mb-5">
          Edit PACI
        </h3>
        <Form form={form} className="flex flex-wrap justify-between">
          <div className="flex-col w-full md:w-[48%]">
            <Label text="Civil ID" />
            <Form.Item
              name="MIN_SUBS_AMT"
              rules={[
                {
                  required: true,
                  message: "Please input civil ID!",
                },
              ]}
            >
              <CustomInput placeholder="Enter civil ID" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Full Name En" />
            <Form.Item
              name="Full Name En"
              rules={[
                {
                  required: true,
                  message: "Please input Full Name En!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Full Name En" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Full Name Ar" />
            <Form.Item
              name="Full Name Ar"
              rules={[
                {
                  required: true,
                  message: "Please input Full Name Ar!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Full Name Ar" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Birth Date" />
            <Form.Item
              name="Birth Date"
              rules={[
                {
                  required: true,
                  message: "Please input Birth Date!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Birth Date" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Gender" />
            <Form.Item
              name="Gender"
              rules={[
                {
                  required: true,
                  message: "Please input Gender!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Gender" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Mobile Number" />
            <Form.Item
              name="Mobile Number"
              rules={[
                {
                  required: true,
                  message: "Please input Mobile Number!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Mobile Number" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Email Address" />
            <Form.Item
              name="Email Address"
              rules={[
                {
                  required: true,
                  message: "Please input Email Address!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Email Address" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Card Expiry Date" />
            <Form.Item
              name="Card Expiry Date"
              rules={[
                {
                  required: true,
                  message: "Please input Card Expiry Date!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Card Expiry Date" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Passport Number" />
            <Form.Item
              name="Passport Number"
              rules={[
                {
                  required: true,
                  message: "Please input Passport Number!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Passport Number" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Card Serial" />
            <Form.Item
              name="Card Serial"
              rules={[
                {
                  required: true,
                  message: "Please input Card Serial!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Card Serial" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Document Number" />
            <Form.Item
              name="Document Number"
              rules={[
                {
                  required: true,
                  message: "Please input Document Number!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Document Number" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Blood Group" />
            <Form.Item
              name="Blood Group"
              rules={[
                {
                  required: true,
                  message: "Please input Blood Group!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Blood Group" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Photo" />
            <Form.Item
              name="Photo"
              rules={[
                {
                  required: true,
                  message: "Please input Photo!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Photo" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Nationality En" />
            <Form.Item
              name="Nationality En"
              rules={[
                {
                  required: true,
                  message: "Please input Nationality En!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Nationality En" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Nationality Ar" />
            <Form.Item
              name="Nationality Ar"
              rules={[
                {
                  required: true,
                  message: "Please input Nationality Ar!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Nationality Ar" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Signature Data" />
            <Form.Item
              name="Signature Data"
              rules={[
                {
                  required: true,
                  message: "Please input Signature Data!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Signature Data" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Signing Certificate" />
            <Form.Item
              name="Signing Certificate"
              rules={[
                {
                  required: true,
                  message: "Please input Signing Certificate!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Signing Certificate" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[48%]">
            <Label text="Data Json" />
            <Form.Item
              name="Data Json"
              rules={[
                {
                  required: true,
                  message: "Please input Data Json!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Data Json" />
            </Form.Item>
          </div>

          <div className="flex w-full flex-wrap items-center justify-between mt-11 border-t-[1px] border-gray-900 pt-5">
            <div className="flex w-[28%] md:w-[48%]">
              <span
                className=" cursor-pointer underline text-gray-700"
                onClick={() => form.resetFields()}
              >
                Reset
              </span>
            </div>
            <div className="flex justify-between items-center w-[70%] md:w-[48%]">
              <button
                type="button"
                className="rounded-lg bg-white w-[48%] py-3 text-center outline-0 cursor-pointer text-sm font-semibold border-[1px] border-blue-500 text-blue-500"
                onClick={() => navigate("/paci-logs")}
              >
                Cancel
              </button>
              <button
                className="rounded-lg bg-blue-500 w-[48%] py-3 text-center outline-0 cursor-pointer text-sm font-semibold border-[1px] border-blue-500 text-white"
                type="button"
                disabled={!submitLoginForm}
              >
                Submit
              </button>
            </div>
          </div>
        </Form>
      </div>
    </section>
  );
};

export default EditPaciLog;
